export default "__VITE_ASSET__CkpIbBYK__"